/* eslint-disable @typescript-eslint/no-explicit-any */
import * as Types from '../../generated/types'

import { gql } from '@apollo/client'
import { ColumnFragmentDoc } from '../Column/Column.generated'
import * as Apollo from '@apollo/client'
const defaultOptions = {} as const
export type TableFragment = {
  __typename?: 'Table'
  id: string
  title?: string | null
  caption?: string | null
  description?: string | null
  columnOrder?: Array<string> | null
  transpose?: boolean | null
  columnCount: number
  dataRowCount: number
  footerRowCount: number
  titleRowCount: number
  rowCount: number
  submitButtonText?: string | null
  meta: { __typename?: 'Meta'; appId: string; projectId?: number | null }
  columns?: Array<
    | {
        __typename?: 'BooleanColumn'
        id: string
        hide?: boolean | null
        highlight?: boolean | null
        pin?: boolean | null
        pinStart?: boolean | null
        pinEnd?: boolean | null
        size?: number | null
        title?: Array<string | null> | null
        showTotals?: boolean | null
        align?: Types.ColumnAlignment | null
        editable?: boolean | null
        boolValues: Array<boolean | null>
        localBoolValues: Array<boolean | null>
        length: number
      }
    | {
        __typename?: 'DateColumn'
        id: string
        hide?: boolean | null
        highlight?: boolean | null
        pin?: boolean | null
        pinStart?: boolean | null
        pinEnd?: boolean | null
        size?: number | null
        title?: Array<string | null> | null
        showTotals?: boolean | null
        align?: Types.ColumnAlignment | null
        editable?: boolean | null
        dateValues: Array<any | null>
        localDateValues: Array<string | null>
      }
    | {
        __typename?: 'DateTimeColumn'
        id: string
        hide?: boolean | null
        highlight?: boolean | null
        pin?: boolean | null
        pinStart?: boolean | null
        pinEnd?: boolean | null
        size?: number | null
        title?: Array<string | null> | null
        showTotals?: boolean | null
        align?: Types.ColumnAlignment | null
        editable?: boolean | null
        dateTimeValues: Array<any | null>
      }
    | {
        __typename?: 'FormulaColumn'
        id: string
        hide?: boolean | null
        highlight?: boolean | null
        pin?: boolean | null
        pinStart?: boolean | null
        pinEnd?: boolean | null
        size?: number | null
        title?: Array<string | null> | null
        showTotals?: boolean | null
        align?: Types.ColumnAlignment | null
      }
    | {
        __typename?: 'NumberColumn'
        id: string
        hide?: boolean | null
        highlight?: boolean | null
        pin?: boolean | null
        pinStart?: boolean | null
        pinEnd?: boolean | null
        size?: number | null
        title?: Array<string | null> | null
        showTotals?: boolean | null
        align?: Types.ColumnAlignment | null
        editable?: boolean | null
        numberValues: Array<number | null>
        localNumberValues: Array<number | null>
        length: number
        currencyCode?: string | null
        percent?: boolean | null
        fractionDigits?: number | null
      }
    | {
        __typename?: 'TextColumn'
        id: string
        hide?: boolean | null
        highlight?: boolean | null
        pin?: boolean | null
        pinStart?: boolean | null
        pinEnd?: boolean | null
        size?: number | null
        title?: Array<string | null> | null
        showTotals?: boolean | null
        align?: Types.ColumnAlignment | null
        editable?: boolean | null
        textValues: Array<string | null>
        options?: Array<string | null> | null
        localTextValues: Array<string | null>
        isStorageBlob?: boolean | null
        length: number
      }
  > | null
}

export type TableQueryVariables = Types.Exact<{
  appId: Types.Scalars['ID']
  tableId: Types.Scalars['ID']
  projectId?: Types.InputMaybe<Types.Scalars['Int']>
  filters: Array<Types.FieldInput> | Types.FieldInput
  extraInputs?: Types.InputMaybe<Array<Types.QueryInput> | Types.QueryInput>
}>

export type TableQuery = {
  __typename?: 'Query'
  app?: {
    __typename?: 'App'
    tableById?: {
      __typename?: 'Table'
      id: string
      title?: string | null
      caption?: string | null
      description?: string | null
      columnOrder?: Array<string> | null
      transpose?: boolean | null
      columnCount: number
      dataRowCount: number
      footerRowCount: number
      titleRowCount: number
      rowCount: number
      submitButtonText?: string | null
      meta: { __typename?: 'Meta'; appId: string; projectId?: number | null }
      columns?: Array<
        | {
            __typename?: 'BooleanColumn'
            id: string
            hide?: boolean | null
            highlight?: boolean | null
            pin?: boolean | null
            pinStart?: boolean | null
            pinEnd?: boolean | null
            size?: number | null
            title?: Array<string | null> | null
            showTotals?: boolean | null
            align?: Types.ColumnAlignment | null
            editable?: boolean | null
            boolValues: Array<boolean | null>
            localBoolValues: Array<boolean | null>
            length: number
          }
        | {
            __typename?: 'DateColumn'
            id: string
            hide?: boolean | null
            highlight?: boolean | null
            pin?: boolean | null
            pinStart?: boolean | null
            pinEnd?: boolean | null
            size?: number | null
            title?: Array<string | null> | null
            showTotals?: boolean | null
            align?: Types.ColumnAlignment | null
            editable?: boolean | null
            dateValues: Array<any | null>
            localDateValues: Array<string | null>
          }
        | {
            __typename?: 'DateTimeColumn'
            id: string
            hide?: boolean | null
            highlight?: boolean | null
            pin?: boolean | null
            pinStart?: boolean | null
            pinEnd?: boolean | null
            size?: number | null
            title?: Array<string | null> | null
            showTotals?: boolean | null
            align?: Types.ColumnAlignment | null
            editable?: boolean | null
            dateTimeValues: Array<any | null>
          }
        | {
            __typename?: 'FormulaColumn'
            id: string
            hide?: boolean | null
            highlight?: boolean | null
            pin?: boolean | null
            pinStart?: boolean | null
            pinEnd?: boolean | null
            size?: number | null
            title?: Array<string | null> | null
            showTotals?: boolean | null
            align?: Types.ColumnAlignment | null
          }
        | {
            __typename?: 'NumberColumn'
            id: string
            hide?: boolean | null
            highlight?: boolean | null
            pin?: boolean | null
            pinStart?: boolean | null
            pinEnd?: boolean | null
            size?: number | null
            title?: Array<string | null> | null
            showTotals?: boolean | null
            align?: Types.ColumnAlignment | null
            editable?: boolean | null
            numberValues: Array<number | null>
            localNumberValues: Array<number | null>
            length: number
            currencyCode?: string | null
            percent?: boolean | null
            fractionDigits?: number | null
          }
        | {
            __typename?: 'TextColumn'
            id: string
            hide?: boolean | null
            highlight?: boolean | null
            pin?: boolean | null
            pinStart?: boolean | null
            pinEnd?: boolean | null
            size?: number | null
            title?: Array<string | null> | null
            showTotals?: boolean | null
            align?: Types.ColumnAlignment | null
            editable?: boolean | null
            textValues: Array<string | null>
            options?: Array<string | null> | null
            localTextValues: Array<string | null>
            isStorageBlob?: boolean | null
            length: number
          }
      > | null
    } | null
  } | null
}

export const TableFragmentDoc = gql`
  fragment Table on Table {
    meta {
      appId
      projectId
    }
    id
    title
    caption
    description
    columnOrder
    transpose
    columns {
      ...Column
    }
    columnCount
    dataRowCount
    footerRowCount
    titleRowCount
    rowCount
    submitButtonText
  }
  ${ColumnFragmentDoc}
`
export const TableDocument = gql`
  query Table($appId: ID!, $tableId: ID!, $projectId: Int, $filters: [FieldInput!]!, $extraInputs: [QueryInput!]) {
    app(id: $appId, projectId: $projectId, filters: $filters, extraInputs: $extraInputs) {
      tableById(id: $tableId) {
        ...Table
      }
    }
  }
  ${TableFragmentDoc}
`

/**
 * __useTableQuery__
 *
 * To run a query within a React component, call `useTableQuery` and pass it any options that fit your needs.
 * When your component renders, `useTableQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTableQuery({
 *   variables: {
 *      appId: // value for 'appId'
 *      tableId: // value for 'tableId'
 *      projectId: // value for 'projectId'
 *      filters: // value for 'filters'
 *      extraInputs: // value for 'extraInputs'
 *   },
 * });
 */
export function useTableQuery(baseOptions: Apollo.QueryHookOptions<TableQuery, TableQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<TableQuery, TableQueryVariables>(TableDocument, options)
}
export function useTableLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TableQuery, TableQueryVariables>) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<TableQuery, TableQueryVariables>(TableDocument, options)
}
export type TableQueryHookResult = ReturnType<typeof useTableQuery>
export type TableLazyQueryHookResult = ReturnType<typeof useTableLazyQuery>
export type TableQueryResult = Apollo.QueryResult<TableQuery, TableQueryVariables>
